/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { CommandBar, Selection, CommandBarButton, DetailsList, DirectionalHint, FontIcon, ICommandBarItemProps, IObjectWithKey, IOverflowSetItemProps, OverflowSet, SelectionMode, TooltipHost, MarqueeSelection, CheckboxVisibility, Stack, IDetailsListProps, IDetailsRowStyles, DetailsRow } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { IPlantillaVerificacion } from "../../../Interfaces/IPlantillaVerificacion";
import IPERCService from "../../../services/IPERCService";
import IconHelper from "../../../utils/helpers/iconHelper";
import themeBase from "../../../utils/theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import NuevoProceso from "./NuevoProceso";
import DefinirNuevoIpercBase from "./DefinirNuevoIpercBase";
import { IItemIPERC } from "../../../Interfaces/IIPERC";
import { IIpercActividad } from "../../../Interfaces/IIpercBase";
import NuevaActividad from "./NuevoActividad";
import DefaultSelect from "../../../components/generic/defaultSelect";
import { _onRenderHeaderAllheight } from "../../../utils/helpers/helpers";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";
import COLORES from "../../../utils/theme/colores";

function IpercBaseVista() {
    const [procesos, setProcesos] = useState<IPlantillaVerificacion[]>([]);
    const [iprecs, setIprecs] = useState<IItemIPERC[]>([]);
    const [actividades, setActividades] = useState<IIpercActividad[]>([]);
    const [isOpenNuevoProceso, { setTrue: openNuevoProceso, setFalse: dismissNuevoProceso }] = useBoolean(false);
    const [isOpenNuevoIpercBase, { setTrue: openNuevoIpercBase, setFalse: dismissNuevoIpercBase }] = useBoolean(false);
    const [isOpenNuevoPeligro, { setTrue: openNuevoPeligro, setFalse: dismissNuevoPeligro }] = useBoolean(false);

    const [itemSeleccionado, setItemSeleccionado] = useState<IObjectWithKey>();
    const [itemSeleccionadoValue, setItemSeleccionadoValue] = useState<IItemIPERC>();

    const [isLoadingData, { toggle: toggleLoadingData }] = useBoolean(false);


    const dataProcesos = useCallback((filter?: Ifilter) => {
        setProcesos([])
        IPERCService.listaProcesos().then((res) => {
            setProcesos(res.data)
        })
    }, [])

    const dataActividades = useCallback((filter?: string) => {
        setActividades([])
        toggleLoadingData()
        IPERCService.ListaActividades().then((res) => {
            console.log(res.data)
            let d: IIpercActividad[] = res.data
            let c: IIpercActividad[] = []
            // eslint-disable-next-line array-callback-return
            d.map((arg: IIpercActividad, i) => {
                c.push({
                    actividadId: arg.actividadId,
                    nombre: arg.nombre,
                    created: arg.created,
                    modified: arg.modified
                    // ipercId: i.toString(),
                    // key: arg.actividadId,
                    // persona: arg.nombre,
                    // actividad: arg.nombre,
                    // area: '',
                    // ubicacion: '',
                    // estado: arg.modified,
                    // fechaResgitro: arg.modified,
                    // nroDOI: ''
                })
            })
            setActividades(c)
            toggleLoadingData()
        }).catch((e: Error) => {
            alert(e.message)
            toggleLoadingData()
        })
    }, [toggleLoadingData])

    const dataIpercs = useCallback((filter: Ifilter) => {
        setIprecs([])
        IPERCService.listaIpercs(filter).then((res) => {
            // console.log(res.data.items)
            let d = res.data.items
            setIprecs(d)
        })
    }, [])

    const _onRenderItemColumEstado = (item: any,) => {
        let resul = <>{item.created}</>
        switch (item.created) {
            case "Rechazado":
                resul =
                    <Stack verticalAlign="space-around">
                        <TooltipHost content='Rechazado' >
                            <FontIcon iconName="IncidentTriangle" style={{ color: themeBase.colorsBaseMessaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "Verificado":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Verificado' >
                            <FontIcon iconName="SkypeCircleCheck" style={{ color: COLORES.Messaging.SuccessIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "Pendiente":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Pendiente' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            case "":
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='Pendiente' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                        </TooltipHost>
                    </Stack>
                break
            default:
                resul =
                    <Stack verticalAlign="space-around" horizontalAlign="center">
                        <TooltipHost content='-' >
                            <FontIcon iconName="SkypeCircleClock" style={{ color: COLORES.Messaging.SevereWarningIcon }} />
                            {/* <FontIcon iconName="StatusCircleQuestionMark" style={{ color: COLORES.Messaging.ErrorBlockIcon }} /> */}
                        </TooltipHost>
                    </Stack>
                break;
        }
        return resul
    }

    const _columns = [
        {
            key: 'nombre',
            name: 'Nombre',
            fieldName: 'nombre',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
            onRender: (item: IIpercActividad) => (
                <Stack verticalAlign="space-around">
                    <p style={{ margin: 0, fontSize: '12px' }}>{item.nombre}</p>
                    <span style={{ marginTop: 2, fontSize: '11px' }}>
                        <FontIcon iconName="Calendar" style={{
                            color: COLORES.Bases.primary,
                            marginRight: 4
                        }} />
                        {item.created.substring(0, 10)}

                        <FontIcon iconName="HourGlass" style={{
                            color: themeBase.colorsBaseMessaging.ErrorBlockIcon,
                            marginLeft: 4,
                        }} />
                        {item.created.substring(10, item.created.length)}
                    </span>
                </Stack>
            ),
        },
        {
            key: 'estado',
            name: 'Estado',
            fieldName: 'estado',
            minWidth: 5,
            maxWidth: 5,
            isResizable: true,
            onRender: _onRenderItemColumEstado
        },
        // {
        //     key: 'name',
        //     name: 'Fecha Creacion',
        //     fieldName: 'name',
        //     minWidth: 100,
        //     maxWidth: 200,
        //     isResizable: true,
        //     onRender: (item: IPlantillaVerificacion) => (
        //         <>
        //             <span>{item.fechaCreacion}</span>
        //         </>
        //     )
        // },
        {
            key: 'value',
            name: 'Opciones',
            fieldName: 'value',
            minWidth: 10,
            maxWidth: 10,
            isResizable: true,
            onRender: (item: IIpercActividad) => (
                <Stack verticalAlign="space-around" horizontalAlign="center">
                    <OverflowSet
                        items={[]}
                        overflowItems={[
                            {
                                key: 'item1',
                                name: 'Nuevo Peligro',
                                iconProps: { iconName: "add" },
                                onClick: () => { openNuevoPeligro() }
                            },
                            {
                                key: 'item3',
                                name: 'Editar',
                                iconProps: { iconName: "edit" }
                            }
                        ]}
                        onRenderOverflowButton={onRenderOverflowButton}
                        onRenderItem={onRenderItem}
                    />
                </Stack>
            )
        },
    ];
    const _CommandBarItem: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_ADD,
            onClick: openNuevoIpercBase
            // subMenuProps: {
            //     items: [
            //         {
            //             key: 'proceso',
            //             text: 'Proceso',
            //             iconProps: { iconName: 'ProcessMetaTask' },
            //             // ['data-automation-id']: 'newEmailButton', // optional
            //             onClick: openNuevoProceso,
            //         },
            //         {
            //             key: 'IPERC',
            //             text: 'Nueva Actividad',
            //             iconProps: { iconName: 'NewTeamProject' },
            //             onClick: openNuevoIpercBase
            //         }
            //     ],
            // },

        },
        {
            ...IconHelper.ICON_RELOAD,
            onClick: () => { dataActividades() }
        },
    ]

    useEffect(() => {
        dataActividades()
        // dataIpercs(_initialFilter())
        // dataProcesos(_initialFilter())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const _selection = new Selection({ onSelectionChanged: () => { setItemSeleccionado(_selection.getSelection()[0]) } })

    useEffect(() => {
        if (itemSeleccionado) {
            let itemValue = itemSeleccionado as IItemIPERC
            setItemSeleccionadoValue(itemValue)
        }
    }, [itemSeleccionado]);

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_BS_FILTER,
            text: 'Filtrar',
        },]
    const StyleVar = { boxSizing: 'border-box', border: '1px solid #eee' }
    const _onRenderRow: IDetailsListProps['onRenderRow'] = props => {
        const customStyles: Partial<IDetailsRowStyles> = {};
        if (props) {
            customStyles.root = {
                // margin: '5px 0 5px 0',
                // borderRadius: '5px',
                padding: '2px 0 2px 0',
                border: themeBase.theme.effects.elevation4,
            };
            customStyles.fields = {
                textAlign: "start",
                alignItems: "center",
            }
            return <DetailsRow {...props} styles={customStyles} />;
        }
        return null;
    };

    return (
        <>

            <Stack padding={5}>
                <CommandBar
                    items={_CommandBarItem}
                    farItems={[]}
                    styles={themeBase.commadStylesWithPadding}
                />
            </Stack>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-md3 ms-lg3 ms-depth-4">
                        <div className="ms-Grid-col ms-lg12">
                            <CommandBar
                                items={[]}
                                farItems={_items}
                                styles={{ root: { height: 25, padding: "6px 0 6px 0" } }}
                            />
                        </div>
                        <div className="ms-Grid-col ms-lg12" >
                            {HelpersIpercBase.LoadingData(!isLoadingData)}

                            <MarqueeSelection selection={_selection}>
                                <DetailsList
                                    items={actividades}
                                    columns={_columns}
                                    selectionMode={SelectionMode.single}
                                    isHeaderVisible={false}
                                    compact={true}
                                    styles={_onRenderHeaderAllheight}
                                    onRenderRow={_onRenderRow}
                                    selection={_selection}
                                    checkboxVisibility={CheckboxVisibility.hidden}
                                />
                            </MarqueeSelection>
                        </div>
                    </div>
                    {itemSeleccionado ?
                        <div className="ms-Grid-col ms-md9 ms-lg9 " >
                            <DefinirNuevoIpercBase
                                actividadId={itemSeleccionadoValue?.actividadId!}
                                isOpenNuevoPeligro={isOpenNuevoPeligro}
                                onDismissNuevoPeligro={dismissNuevoPeligro}
                            />
                        </div> : <DefaultSelect iconName="Dialpad" />
                    }

                </div>
            </div>

            <NuevoProceso
                isOpen={isOpenNuevoProceso}
                onDismiss={dismissNuevoProceso}
            />

            <NuevaActividad
                isOpen={isOpenNuevoIpercBase}
                onDismiss={dismissNuevoIpercBase}
                setup={() => { dataActividades() }}
            />

        </>
    );
}

export default IpercBaseVista;

const onRenderOverflowButton = (overflowItems: any[] | undefined): JSX.Element => {
    return (
        <TooltipHost content="Opciones" directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
                aria-label="More items"
                menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: overflowItems! }}
                styles={{ root: { background: "none"} }}
            />
        </TooltipHost>
    );
};

const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
    return (
        <TooltipHost content={item.title} directionalHint={DirectionalHint.leftCenter}>
            <CommandBarButton
                aria-label={item.name}
                iconProps={{ iconName: item.icon }}
                onClick={item.onClick}
                styles={{ root: { background: "none" } }}
            />
        </TooltipHost>
    );
};